import { render, staticRenderFns } from "./AdminBarcodeInput.vue?vue&type=template&id=22f20ed9&scoped=true&"
import script from "./AdminBarcodeInput.vue?vue&type=script&lang=js&"
export * from "./AdminBarcodeInput.vue?vue&type=script&lang=js&"
import style0 from "./AdminBarcodeInput.vue?vue&type=style&index=0&id=22f20ed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f20ed9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f20ed9')) {
      api.createRecord('22f20ed9', component.options)
    } else {
      api.reload('22f20ed9', component.options)
    }
    module.hot.accept("./AdminBarcodeInput.vue?vue&type=template&id=22f20ed9&scoped=true&", function () {
      api.rerender('22f20ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminBarcodeInput.vue"
export default component.exports